import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// B2C TRUV slice — mirrors the B2B truv endpoints but hits the consumer
// surface (b2c/loan/truv_api/*), which isn't gated by loan-officer access.
export const truvConsumerAPI = createApi({
  reducerPath: 'truvConsumer',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    createTruvIntegration: builder.mutation({
      query: ({ data }) => ({
        url: `b2c/loan/truv_api/bridge-token`,
        method: 'POST',
        body: data,
        headers: getHeaders(),
      }),
    }),

    getNewTruvLinkId: builder.mutation({
      query: ({ data }) => ({
        url: `b2c/loan/truv_api/link-id`,
        method: 'POST',
        body: data,
        headers: getHeaders(),
      }),
    }),

    getFullTruvReport: builder.mutation({
      query: ({ employmentRecordId, forceRefresh = false }) => ({
        url: `b2c/loan/truv_api/report/${employmentRecordId}`,
        method: 'GET',
        params: { forceRefresh },
        headers: getHeaders(),
      }),
    }),

    getTruvEvents: builder.query({
      query: ({ employmentRecordId, limit = 20 }) => ({
        url: `b2c/loan/truv_api/events/${employmentRecordId}`,
        method: 'GET',
        params: { limit },
        headers: getHeaders(),
      }),
    }),
  }),
});

export const {
  useCreateTruvIntegrationMutation,
  useGetNewTruvLinkIdMutation,
  useGetFullTruvReportMutation,
  useGetTruvEventsQuery,
} = truvConsumerAPI;
